export const formatMoney = (amount, decimalPlaces = 2) => {
   const formatter = new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: decimalPlaces,
   });
   return formatter.format(amount);
};
